export class FormFile {
    buttonTPL = '<button class="form-file__button">Seleccionar archivo</button>';
    labelTPL = '<label class="form-file__label">Adjuntar archivo</label>';

    // staff
    file;

    constructor() {
        this.init();
    }

    init() {
        this.file = $('.form-file');

        if (!this.file.length) {
            return;
        }

        this.setFormFile();
        this.bindFormFileEvents();
    }

    // fn's
    setFormFile() {
        this.file.find(':file').each(() => {
            const label = $('label[for="' + this.id + '"]').prop('class', 'form-file__label') || $(this.labelTPL).prop('for', this.id);

            $(this)
                .hide()
                .after(this.buttonTPL, label);
        });
    }

    bindFormFileEvents() {
        this.file.on('click', '.form-file__button', (e) => {
            e.preventDefault();

            $(this).siblings(':file').trigger('click');
        });
    }
}
